module.exports = __webpack_public_path__ + "img/theesports2014summercollection.7e0a88a3.png";